import { render, staticRenderFns } from "./ImageModeMenuItem.vue?vue&type=template&id=23e49beb&scoped=true"
import script from "./ImageModeMenuItem.vue?vue&type=script&lang=ts"
export * from "./ImageModeMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./ImageModeMenuItem.vue?vue&type=style&index=0&id=23e49beb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e49beb",
  null
  
)

export default component.exports